import { api, desenvolver } from '../api';
import type { LoginRequest, Usuario } from '../api';
import { abrirSesion, refrescarIdentidad } from './almacen';
import type { Sesion } from './almacen';

/**
 * Las dos llamadas de identidad del contrato. Están separadas del almacén para
 * que éste no dependa de la red y se pueda probar solo.
 */

/**
 * `POST /api/v1/auth/login`. Si sale bien, deja la sesión abierta.
 *
 * Si sale mal lanza un `ErrorApi` —normalmente `credenciales_invalidas`— y no
 * toca la sesión. **Quien muestre ese error no debe mostrar `detalle` crudo**:
 * ver `mensajeDeLogin`.
 */
export async function iniciarSesion(credenciales: LoginRequest): Promise<Sesion> {
  const respuesta = await desenvolver(api.POST('/api/v1/auth/login', { body: credenciales }));
  return abrirSesion(respuesta);
}

/**
 * `GET /api/v1/auth/yo`. Relee del backend quién es el dueño del token y
 * actualiza nombre y rol de la sesión abierta.
 *
 * Es una operación **sin efectos** y es el único lugar donde el front se entera
 * de un cambio de rol hecho por otra persona. Si el usuario fue desactivado, la
 * respuesta es `401` y el enganche del almacén cierra la sesión sola: por eso
 * acá no hay ningún `catch` de ese caso.
 */
export async function releerIdentidad(): Promise<Usuario> {
  const usuario = await desenvolver(api.GET('/api/v1/auth/yo'));
  refrescarIdentidad({ nombre: usuario.nombre, email: usuario.email, rol: usuario.rol });
  return usuario;
}
